import { clearAllCookies } from './cookies';

export function setItem(name: string, value: any, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    if (typeof value === 'string') {
        storage.setItem(str, value);
    } else {
        storage.setItem(str, JSON.stringify(value));
    }
}
export function getItem(name: string, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    if (!storage.getItem(str)) {
        return '';
    } else {
        const value = storage.getItem(str) || '';
        if (isJSON(value)) {
            return JSON.parse((storage.getItem(str) as string) || '{}');
        } else {
            return value;
        }
    }
}
export function removeItem(name: string, type = 'ls') {
    const storage = type === 'ls' ? localStorage : sessionStorage;
    const str = name;
    storage.removeItem(str);
}
export function clear() {
    const keysToRemove: string[] = [];
    const whiteKeys = ['s2t1_batch_guide_visited', 's2t1_map_visited'];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && !whiteKeys.includes(key)) {
            keysToRemove.push(key);
        }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    sessionStorage.clear();
    clearAllCookies();
}
function isJSON(str: string) {
    if (typeof str == 'string') {
        try {
            const obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }
}
